"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Client component that redirects authenticated users to the dashboard.
 * Checks localStorage/sessionStorage for an access token — no API call needed.
 * Drop this into server-rendered public pages (home, landing) to mirror
 * the GitHub-style "logged in? go to dashboard" behavior.
 */
export default function AuthRedirect() {
  const router = useRouter();

  useEffect(() => {
    const token =
      localStorage.getItem("sf_access_token") ??
      sessionStorage.getItem("sf_access_token");
    if (token) {
      router.replace("/dashboard");
    }
  }, [router]);

  return null;
}
